
/** @jsxImportSource react */
import React from 'react';

import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ProblemasSection from './components/ProblemasSection';
import QuantoReceberSection from './components/QuantoReceberSection';
import ComoFuncionaSection from './components/ComoFuncionaSection';
import GarantiaSection from './components/GarantiaSection';
import FormularioSection from './components/FormularioSection';
import FaqSection from './components/FaqSection';
import CtaFinalSection from './components/CtaFinalSection';
import Footer from './components/Footer';

export default function HomePage() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Navbar scrollToSection={scrollToSection} />
      <HeroSection scrollToSection={scrollToSection} />
      <ProblemasSection scrollToSection={scrollToSection} />
      <QuantoReceberSection scrollToSection={scrollToSection} />
      <ComoFuncionaSection scrollToSection={scrollToSection} />
      <GarantiaSection scrollToSection={scrollToSection} />
      <FormularioSection />
      <FaqSection />
      <CtaFinalSection />
      <Footer />
    </div>
  );
}
